(function () {
	'use strict';

	angular
		.module('wizard-english-test.configs', [])
		.config(InterceptorConfig);

	/** @ngInject */
	function InterceptorConfig() {

	}
}());